declare var pglob : IPhotometerGlobalVar;

module product {
  'use strict';

  export class ProductCtrl {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      '$location', 
      '$anchorScroll', 
      '$window', 
      '$http', 
      '$timeout',
      'anchorNavService',
      'pageMetaService',
      '$mdDialog',
      '$templateCache',
      '$sce', 
    ];

    // dependencies are injected via AngularJS $injector
    constructor(
      private $scope: IProductScope,
      private $location: ng.ILocationService,
      private $anchorScroll: ng.IAnchorScrollService,
      private $window: ng.IWindowService,
      private $http: ng.IHttpService,
      private $timeout: ng.ITimeoutService,
      private anchorNavService : navigation.IAnchorNavService,
      private pageMetaService: navigation.IPageMetaService,
      private $mdDialog: ng.material.IDialogService,
      private $templateCache : ng.ITemplateCacheService
      , private $sce: ng.ISCEService
      ) {
     
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      $scope.editBtnVisible = false;


      //this.load(pglob.RouteData.RouteEntry);
      anchorNavService.subscribeOnLocationChanged($scope, (event :ng.IAngularEvent, re:IRouteEntry) => {
        this.load(re);
      });
      this.load(pglob.RouteData.RouteEntry);


      $scope.checkOverflow = () => {        
        var el: JQuery = $(".overflow-wrapper .content:visible");
        //console.log(el);

        if ($scope.expanded) {
          $scope.expanded = false;
          el.on("transitionend", (e) =>  {
            if(e.target !== e.currentTarget) return;
           	el.off(e);
            this.$timeout(() => { $scope.checkOverflow(); });
          });            
        }

        var totalHeight = 0;
        var child: JQuery = el.children(":visible").each(function() {
            totalHeight = totalHeight + $(this).outerHeight(true);
        });;
        //console.log(totalHeight);
        //console.log(el.prop("offsetHeight"));

        $scope.overflow = totalHeight > el.prop("offsetHeight");      
        
        if (this.pageMetaService.getPageMeta().RouteData.Features.AdminTools) {
          el.bind('mouseenter', () => { $scope.editBtnVisible = true; });
          el.bind('mouseleave', () => { $scope.editBtnVisible = false; }); 
        }
      };
      
    } 

    changeProduct(re : IRouteEntry, event? : any, animDirectionClass? : string) {
      if (event) event.preventDefault();
      this.$scope.animDirection = animDirectionClass;
      this.anchorNavService.updateRouteParameters(re, true);
    }

    load(re:IRouteEntry) {

      this.$scope.product = null;
      this.$scope.img = null;

      this.$http<ProductData>({
                  method: "POST"
                , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Product/"
                , headers: { 'Content-Type': 'application/json' }
                , params: {}
                , data : re.RouteParameterStack
        }).then(( response : {data : ProductData}) => {
          if (response.data.Product.KillingDate) response.data.Product.KillingDate = new Date(<any>response.data.Product.KillingDate); //we recieve that as string, have to convert it.
          this.$scope.status = "success";
          this.$scope.product = response.data.Product;
          this.$scope.img = response.data.ProductImageName;
          this.$scope.features = response.data.Features;
          this.$scope.current = response.data.Current;
          this.$scope.previous = response.data.Previous;
          this.$scope.next = response.data.Next;
          this.$scope.specs = response.data.Specifications;
          this.$scope.datasheet = response.data.DataSheet;
          this.$scope.controlUnits = response.data.ControlUnits;

          this.$scope.product.LongDesc = this.$sce.trustAsHtml(this.$scope.product.LongDesc);

          //this.$scope.expanded = false;  <-- this does not work, cause then the overflow is not yet present…
          this.$timeout(() => { this.$scope.checkOverflow(); });
        });

    };  

    getDataSheetRevision(hl? : string): library.DocumentRev {
      if (!this.$scope.datasheet) return null;
      var hl = hl || pglob.RouteData.CurrentLanguage.hl;

      var ds = this.$scope.datasheet.Revisions.filter((doc, index, array) => {
        return doc.LanguageCode == hl;
      });
      if (ds.length > 0) return ds[0];

      //otherwise the english one
      if (hl != "E") {
        var dsE : library.DocumentRev = this.getDataSheetRevision("E");
        if (dsE) return dsE;
      }

      if (this.$scope.datasheet.Revisions.length > 0) return this.$scope.datasheet.Revisions[0];
      return null;
    }

    openConfig($event: MouseEvent) : void {
      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'PartOrderDetailCtrl',
        templateUrl: 'part/PartOrderDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: $event,
        clickOutsideToClose: true,
        fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          product: this.$scope.product,
        },
      })
    }

    openEditor($event: Event): void {
      if (!this.pageMetaService.getPageMeta().RouteData.Features.AdminTools) return;

      if (event) event.preventDefault();
          
      var rpv: IRouteParameter[] = pglob.RouteData.RouteEntry.RouteParameterStack;

      var config = {
        "Category": 9,
        "Filter1" : rpv[1].Id,
        "Filter2" : rpv[0].Id,
        "FilterString1": "Produkt", 
        "FilterString2": "Text",         
        "ContentFormat": 77, 
        "useRouteParam": true,
      };

      config['rpv'] = pglob.RouteData.RouteEntry.RouteParameterStack;
          
      var editorTemplate = <string> this.$templateCache.get('editormodaltemplate.html') || editor.EditorModalTemplate();

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'editorCtrl',
        template: editorTemplate,
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: null,
        clickOutsideToClose:false,
        //fullscreen: true, // Only for -xs, -sm breakpoints.
        locals : {
          filter : config
        },
      })
      .then((message : {filter : editor.EditorFilter, data : string}) => { //close
        console.log('Modal closed at: ' + new Date());
        //if (scope.config.replace) {
        //  element.html(message.data);  
        //  wireEditButton();
        //}
      }, (message : {filter : editor.EditorFilter, data : string}) => { //cancel
        console.log('Modal canceled at: ' + new Date());
      });


    }
    
  }

}